var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"brdr-none bg-cl-transparent p15",attrs:{"aria-label":_vm.$t('Remove'),"title":_vm.$t('Remove')}},[_c('i',{staticClass:"material-icons h4"},[_vm._v("close")])])}
var staticRenderFns = []

export { render, staticRenderFns }